import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'

export function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    setLoading(false)
    if (error) { setError(error.message); return }
    navigate('/dashboard')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="h-9 w-9 rounded-xl bg-brand-500 flex items-center justify-center">
            <span className="text-white font-bold text-base">R</span>
          </div>
          <span className="font-semibold text-stone-900 text-xl tracking-tight">RezzOps</span>
        </div>

        <div className="card p-6">
          <h1 className="text-lg font-semibold text-stone-900 mb-1">Sign in</h1>
          <p className="text-sm text-stone-500 mb-6">Welcome back to your restaurant dashboard</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="owner@myrestaurant.com"
            />
            <Input
              label="Password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
            />

            {error && (
              <p className="text-xs text-danger bg-danger-light rounded px-3 py-2">{error}</p>
            )}

            <Button type="submit" className="w-full" loading={loading}>
              Sign in
            </Button>
          </form>
        </div>

        <p className="text-center text-sm text-stone-500 mt-4">
          New restaurant?{' '}
          <Link to="/signup" className="text-brand-600 hover:underline font-medium">Create an account</Link>
        </p>
      </div>
    </div>
  )
}
